<ng-container *ngFor="let node of root">
    <app-graph-node class="root-node"
        [node]="node"
        [ngStyle]="{
            'left': node.gData.position.left + 'px',
            'top': node.gData.position.top + 'px'
        }">
    </app-graph-node>
</ng-container>



